import * as ListInventoryWidget from './listInventory';

export {
    ListInventoryWidget,
};


// WEBPACK FOOTER //
// ./src/components/widget/inventory/index.ts